import { toast } from 'react-toastify';
import useAnnonceGenerator from '../../utils/hook/useAnnonceGenerator';

function AiDescriptionGenerator({ vehicleId, onAccepted }) {
  const { status, description, source, remaining, error, generate, setDescription, accept } =
    useAnnonceGenerator(vehicleId);

  const loading = status === 'loading';
  const saving = status === 'saving';
  const hasDraft = Boolean(description);

  const handleAccept = async () => {
    const saved = await accept();
    if (saved) {
      toast.success('Description enregistrée');
      onAccepted?.(saved);
    }
  };

  return (
    <section className="mc-form-card">
      <span className="mc-section-kicker">DESCRIPTION</span>
      <h2 className="mc-form-title">
        <i className="bi bi-stars me-2" />
        Générer ma description avec l'IA
      </h2>
      <p className="mc-form-subtitle">
        Rédigée à partir des caractéristiques et équipements que vous avez renseignés.
      </p>

      {error && (
        <div className="mc-form-alert" role="alert">
          <span>{error}</span>
        </div>
      )}

      {hasDraft && (
        <div className="mc-field">
          <label className="mc-field-label" htmlFor="ai-description">
            Votre description (modifiable)
          </label>
          <textarea
            id="ai-description"
            className="mc-input"
            rows={7}
            maxLength={2000}
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            disabled={loading || saving}
          />
          {source === 'template' && (
            <p className="mc-field-hint">
              Texte simple généré sans IA (service momentanément indisponible). Vous pouvez le
              compléter.
            </p>
          )}
          <p className="mc-field-hint">
            Relisez le texte : vous restez responsable de l'exactitude de votre annonce.
            {remaining !== null && ` ${remaining} génération(s) restante(s) aujourd'hui.`}
          </p>
        </div>
      )}

      <div className="mc-form-actions">
        <button
          type="button"
          className="mc-btn mc-btn--secondary"
          onClick={generate}
          disabled={loading || saving || !vehicleId}
        >
          {loading ? (
            <>
              <span className="mc-spinner" aria-hidden="true"></span> Génération…
            </>
          ) : hasDraft ? (
            'Régénérer'
          ) : (
            "Générer avec l'IA"
          )}
        </button>

        {hasDraft && (
          <button
            type="button"
            className="mc-btn mc-btn--primary"
            onClick={handleAccept}
            disabled={loading || saving || description.trim().length < 20}
          >
            {saving ? 'Enregistrement…' : 'Utiliser ce texte'}
          </button>
        )}
      </div>
    </section>
  );
}

export default AiDescriptionGenerator;
